.button {
  overflow: visible;
}
